import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExtraExpense } from '../models/extra-expense';
import { ExtraExpenseJob } from '../models/extra-expense-job';

@Injectable({
  providedIn: 'root'
})
export class ExtraExpenseService {

  constructor(private http:HttpClient) { }

  getExtraExpenses(date1:Date, date2:Date) : Promise<ExtraExpense[]> {
    return this.http.get<ExtraExpense[]>('/api/expense/extra', {params: {date1:date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  postExtraExpense(extraExpense:ExtraExpense) : Promise<ExtraExpense> {
    return this.http.post<ExtraExpense>('/api/expense/extra', extraExpense)
      .toPromise();
  }

  getExtraExpense(id:Number) : Promise<ExtraExpense> {
    return this.http.get<ExtraExpense>('/api/expense/extra/' + id)
      .toPromise();
  }
  
  putExtraExpense(extraExpense:ExtraExpense) : Promise<ExtraExpense> {
    return this.http.post<ExtraExpense>('/api/expense/extra/' + extraExpense.id + '/edit', extraExpense)
      .toPromise();
  }
  
  deleteExtraExpense(extraExpense:ExtraExpense) : Promise<void> {
    return this.http.get<void>('/api/expense/extra/' + extraExpense.id + '/delete')
      .toPromise();
  }

  getExtraExpensesJob() : Promise<ExtraExpenseJob[]> {
    return this.http.get<ExtraExpenseJob[]>('/api/expense/job')
      .toPromise();
  }

  postExtraExpenseJob(extraExpenseJob:ExtraExpenseJob) : Promise<ExtraExpenseJob> {
    return this.http.post<ExtraExpenseJob>('/api/expense/job', extraExpenseJob)
      .toPromise();
  }

  getExtraExpenseJob(id:Number) : Promise<ExtraExpenseJob> {
    return this.http.get<ExtraExpenseJob>('/api/expense/job/' + id)
      .toPromise();
  }
  
  putExtraExpenseJob(extraExpenseJob:ExtraExpenseJob) : Promise<ExtraExpenseJob> {
    return this.http.post<ExtraExpenseJob>('/api/expense/job/' + extraExpenseJob.id + '/edit', extraExpenseJob)
      .toPromise();
  }
  
  deleteExtraExpenseJob(extraExpenseJob:ExtraExpenseJob) : Promise<void> {
    return this.http.get<void>('/api/expense/job/' + extraExpenseJob.id + '/delete')
      .toPromise();
  }
}
